<template>
    <v-container class="px-15">
        <v-form ref="notaFiscalForm" :value="formValid">
            
          <v-row class="mx-10">
              <v-col class="text-center py-0" cols="12" v-show="!edicao && parametros && parametros.FAT_TIPO_TITULO">
                  <v-radio-group  
                    v-model="tipo"
                    row
                    mandatory
                  >
                    <v-radio
                      @click="resetCampos()"
                      label="Nota Fiscal"
                      value="1"
                    ></v-radio>
                    <v-radio
                      @click="resetCampos()"
                      label="Título"
                      value="2"
                    ></v-radio>
                  </v-radio-group>
              </v-col>
              <v-col class="text-center py-0" cols="12">
                  <h1 class="mb-2 mt-0" style="font-size:22px;">{{ tipoE == 0 ? tipo == '1' ?'Nota fiscal' : 'Título': ''}} {{ tipoE != 0 ? tipoE == '1' ?'Nota fiscal' : 'Título': '' }}</h1>
                  <p v-if="formData.id == null" class="mb-0" style="font-size:14px;">Informe o dados {{tipo == '1' ? 'da nota fiscal' : 'do título'}} a ser associada aos lotes.</p>
              </v-col>
              <v-col class="py-0 px-2" cols="8">
                  <label>Número</label>
                  <v-text-field
                    v-model="numero"
                    type="number"
                    :placeholder=" tipo == '1' ? 'Número da nota fiscal' : 'Número do título' "
                    single-line
                    outlined
                    dense
                    :rules="formRules.required"
                  ></v-text-field>
              </v-col>
              <v-col class="py-0 px-2" cols="4">
                  <v-checkbox
                    v-model="associar"
                    label="Associar a todos os lotes"
                    hide-details
                    dense
                  ></v-checkbox>
              </v-col>
              <v-col class="py-0 px-2" cols="12">
                <label>CNPJ</label>
                <v-text-field
                  v-model="cnpj"
                  :rules="formRules.cpfCnpjRules"
                  :placeholder="'Número do CNPJ'"
                  v-mask="'##.###.###/####-##'"
                  single-line
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col class="py-0 px-2" cols="6">
                  <label>Data de {{ tipo == '1' ? 'emissão' : 'vencimento'}}</label>
                  <v-menu
                    ref="dtI"
                    v-model="dtI"
                    :close-on-content-click="true"
                    transition="scale-transition"
                    offset-y
                  > <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dateFormatted"
                        dense
                        v-mask="'##/##/####'"
                        format="DD/MM/YYYY"
                        placeholder="DD/MM/AAAA"
                        label
                        outlined
                        v-bind="attrs"
                        v-on="on"
                        append-icon="mdi-calendar-blank"
                        @blur="date = parseDate(dateFormatted)"
                        :rules="[formRules.requiredField,  formRules.typeDateFormated, formRules.minDateNotaFiscal]" 
                      ></v-text-field>
                        <!-- :rules="obrigatorio && obrigatorio.includes('dt_emissao') ? [formRules.requiredField,  formRules.typeDateFormated] : [formRules.typeDateFormated]" -->
                    </template>
                    <v-date-picker color="primary" min="2019-01-01" v-model="date" no-title scrollable></v-date-picker>
                  </v-menu>
              </v-col>
              <v-col class="py-0 px-2" cols="6" v-if="showField">
                  <label>Valor (R$)</label>
                  <v-text-field
                    v-model.lazy="valor"
                    v-money= "money"
                    outlined
                    dense
                    :rules="obrigatorio && obrigatorio.includes('valor')? [formRules.requiredPrice]: []"
                  />
              </v-col> 
              <v-col class="py-0 px-2" cols="12">
                  <label>Link {{tipo == '1' ? 'da nota fiscal' : 'do título'}}</label>
                  <v-text-field
                    v-model="link"
                    :placeholder="tipo == '1' ? 'Ex.: http://www.nfe.fazenda.gov.br/13443556779080' : 'Ex.: http://www.'"
                    single-line
                    outlined
                    dense
                    :rules="obrigatorio && obrigatorio.includes('link')? [formRules.requiredField, formRules.validUrl]  : [formRules.validUrl]"
                  ></v-text-field>
              </v-col>
              <v-col class="py-0 px-2" cols="12">
                  <label>Anexo</label>
                  <v-file-input
                      :placeholder="formData.anexo == null ? tipo == 1 ? 'Selecione o arquivo da nota': 'Selecione o arquivo do titulo' : formData.anexo"   
                      outlined
                      v-model="file"
                      single-line
                      dense
                      :prepend-icon="null"
                      append-icon="fa-upload"
                      :rules="obrigatorio && obrigatorio.includes('anexo') && isNew? [formRules.requiredField] : []"
                      @change="sendFile(file)"
                  ></v-file-input>
              </v-col>
            </v-row>
        </v-form>
    </v-container>
</template>

<script>
import { VMoney } from "v-money";
export default {
  directives: { money: VMoney },
  props: {
      dadosCronograma: Object,
      formData: Object,
      formRules: Object,
      sendFile: Function,
      validateForm: Boolean,
      updateNotaFiscalFormValid: Function,
      obrigatorio: Array,
      tipoE: Number,
      edicao: Boolean,
      getLotes: Function,
      parametros: Object
  },
  data() {
    return {
      isNew: true,
      showField: true,
      formValid: true,
      file: null,
      cnpj: null,
      dateFormatted: null,
      date: null,
      dtI: false,
      dtIT: false,
      valor: null,
      link: null,
      numero: null,
      anexo: null,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false
      },
      tipo: 1,
      associar: false
    }
  },
  watch: {
    parametros(val){
      if(!val.FAT_TIPO_TITULO){
        this.tipo = 1
      }
    },
    tipoE(val){
      this.tipoE != 0 ? this.formData.tipo = val : undefined
      this.tipoE != 0 ? this.tipo = val : undefined
    },
    tipo(val){
      this.tipoE == 0 ? this.formData.tipo = val : undefined
    },
    anexo(val){
      this.formData.anexo = val
    },
    valor(val) {
      this.formData.valor = val? parseFloat(this.valor.replaceAll('.','').replaceAll(',','.')) : null
    },
    validateForm(bool){
      if(bool) {
        this.updateNotaFiscalFormValid( this.$refs.notaFiscalForm.validate() ? true : false)
      } else {
        this.updateNotaFiscalFormValid(false)
      }
    },
    link(val){
      this.formData.link = val
    },
    cnpj(val){
      this.formData.cnpj = val.replace(/[^0-9]/g, '')
    },
    numero(val){
      this.tipoE != 0 ? this.tipoE == 1 ? this.formData.numero = val : this.formData.nr_titulo = val : this.tipo == 1 ? this.formData.numero = val : this.formData.nr_titulo = val
      this.tipoE == 0 ? this.formData.tipo = this.tipo : undefined
    },
    dateFormatted(val) {
      this.tipo == 1 ? this.formData.dt_emissao = this.parseDate(val) : this.formData.data_venc_titulo = this.parseDate(val)
    },
    date(val) { 
      this.dateFormatted = this.formatDate(val);
    },
    associar(val){
      this.formData.associar = val
      this.associar ? this.getLotes(undefined, true) : null
    },
    formData(val) {
      this.valorNota(0.00)
      this.$nextTick(()=> {
        if(val && val.id){
          this.isNew = false
          this.numero = this.tipoE == 1 ? val.numero : val.nr_titulo
          this.cnpj = val.cnpj
          this.link = val.link
          this.date = this.tipoE == 1 ? val.dt_emissao : val.data_venc_titulo
          this.valorNota(val.valor)
          this.associar = val.associar
        } 
        else {
          this.isNew = true
          this.file = null
          this.numero = null
          this.link = null
          this.date = null
          this.cnpj = this.dadosCronograma.cnpj
          this.valorNota(0)
          this.associar = false
        }
        setTimeout(()=>{
          this.$refs.notaFiscalForm.resetValidation()
        },50)
      })
    },
    
  },
  mounted(){
    setTimeout(()=>{
      this.$refs.notaFiscalForm.resetValidation()
    },50)

  },
  methods: {
    valorNota(val) {
      this.showField = false
      this.valor = (val/1).toFixed(2).toString().replace('.', ',')
      this.valor = this.valor.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      setTimeout(() => {this.showField = true}, 30)
    },
    formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('T')[0].split('-')
        return `${day}/${month}/${year}`
    },
    parseDate (date) {
        if (!date) return null
        const [day, month, year] = date.split('/')
        return `${year}-${month}-${day}`
    },
    resetCampos(){
      this.valorNota(0)
      this.file = null
      this.dateFormatted = null
      this.date = null 
      this.dtI = false 
      this.dtIT = false 
      this.valor = null
      this.link = null
      this.numero = null
      this.cnpj = null
      this.anexo = null

      this.formData.numero = null
      this.formData.cnpj = null
      this.formData.nr_titulo = null
      this.formData.data_venc_titulo = null
      this.formData.dt_emissao = null

    }
  },
  
}
</script>

<style>

</style>